import { StyleSheet } from "react-native";
import { addFontFamilylato } from "./utils/services/CommonUtils";

import Colors from "./utils/constants/AppColors";

const TextStyle = StyleSheet.create(addFontFamilylato({
    text6: {
        fontSize: 6,
    },
    text6b: {
        fontSize: 6,
        fontWeight: 600
    },
    text8: {
        fontSize: 8,
    },
    text8b: {
        fontSize: 8,
        fontWeight: 600
    },
    text9b: {
        fontSize: 9,
        fontWeight: 600
    },
    text9: {
        fontSize: 9,
    },
    text9xb: {
        fontSize: 9,
        fontFamily: 'Lato_900Black'
    },
    text10: {
        fontSize: 10,
    },
    text10b: {
        fontSize: 10,
        fontWeight: 600
    },
    text10xb: {
        fontSize: 10,
        fontFamily: 'Lato_900Black'
    },
    text11: {
        fontSize: 11,
    },
    text11b: {
        fontSize: 11,
        fontWeight: 600,

    },
    text11xb: {
        fontSize: 11,
        fontWeight: 600,
        fontFamily: 'Lato_900Black'
    },
    text12: {
        fontSize: 12,
    },
    text12b: {
        fontSize: 12,
        fontWeight: 600
    },
    text12xb: {
        fontSize: 12,
        fontFamily: 'Lato_900Black'
    },
    text14: {
        fontSize: 14,
    },
    text14b: {
        fontSize: 14,
        fontWeight: 600
    },
    text14xb: {
        fontSize: 14,
        fontFamily: 'Lato_900Black'
    },
    text16: {
        fontSize: 16,
    },
    text16b: {
        fontSize: 16,
        fontWeight: 600
    },
    text16xb: {
        fontSize: 16,
        fontFamily: 'Lato_900Black'
    },
    text18: {
        fontSize: 18,
    },
    text18b: {
        fontSize: 18,
        fontWeight: 600
    },
    text18xb: {
        fontSize: 18,
        fontFamily: 'Lato_900Black'
    },
    text20: {
        fontSize: 20,
    },
    text20b: {
        fontSize: 20,
        fontWeight: 600
    },
    text20xb: {
        fontSize: 20,
        fontFamily: 'Lato_900Black'
    },
    text24: {
        fontSize: 24,
    },
    text24b: {
        fontSize: 24,
        fontWeight: 600
    },
    text24xb: {
        fontSize: 24,
        fontFamily: 'Lato_900Black'
    },

    flexWrap: { flexWrap: "wrap" },

    uppercase: { textTransform: 'uppercase' },
    capitalize: { textTransform: 'capitalize' },
    underline: { textDecorationLine: "underline" },
    lineThrough: { textDecorationLine: "line-through" },

    alignLeft: { textAlign: 'left' },
    alignRight: { textAlign: "right" },
    alignCenter: { textAlign: "center" },

    colorWhite: { color: Colors.white },
    colorGrey: { color: Colors.grey.text },
    colorPrimary: { color: Colors.primary }
}))

export default TextStyle;